module.exports = __webpack_public_path__ + "static/media/define_ie.1ce42f7d.png";